import { Show, useContext } from 'solid-js';
import { Text } from '../../ui-components/text/text';
import { AppContext } from '../../app-context-provider/app-context-provider';
import theme from '../../style/theme';
import { OrderDetails } from './user-order-history';
import { StyledHistoryOrderLine, StyledHistoryOrderLineWrapper, StyledImageHolder, StyledTextContent } from './user-order-history.styles';
import { ImageComponent } from '../image-component/image-component';
import { Link } from '../../ui-components/link/link';
import { StyledVerticalSpace } from '../../ui-components/utility-style-components/spacing';
import { useNavigate } from '@solidjs/router';


type OrderHistoryOrderlineProps = {
    orderDetails: OrderDetails;
    lastElement: (el: any) => void;
};

const OrderHistoryOrderline = (props: OrderHistoryOrderlineProps) => {
    const { viewport, localize, productsEntityName, appStore } = useContext(AppContext);
    const { closeLoginMenu } = appStore;

    const navigate = useNavigate();

    const isDesktop = () => viewport.width > theme.breakpoints.ORIGINAL_TABLET;

    return (
        <StyledHistoryOrderLineWrapper>
            <StyledHistoryOrderLine>
                
                <StyledImageHolder>
                    <Show when={props.orderDetails.imageUrl}>
                        <ImageComponent
                            src={props.orderDetails.imageUrl!}
                            height={'AUTO'}
                            width={300}
                            altText={'Product image for ' + props.orderDetails.skuName}
                            aspectRatio={'original'}
                            ratio={props.orderDetails.imageRatio}
                        />
                    </Show>
                </StyledImageHolder>

                <StyledTextContent>
                    <Link 
                        url=''
                        asButton
                        label={`${props.orderDetails.amount} x ${props.orderDetails.skuName}`}
                        noBlockSpacing
                        customCss='text-align: left;'
                        onClick={() => {
                            navigate(`/${productsEntityName}/${props.orderDetails.slug}`);
                            closeLoginMenu();
                        }}
                        element={(el: HTMLButtonElement) => props.lastElement(el)}
                    />
                    <StyledVerticalSpace size={0.5} />
                    <Text fontSize='small' noBlockSpacing color='gray' lineLimit={isDesktop() ? 2 : 3}>{
                        props.orderDetails.skuDescription
                    }</Text>
                    <Text fontSize='small' color='gray' noBlockSpacing>{
                        `${props.orderDetails.skuQuantity ? `${localize('units-per-pack', 'Units per pack')}: ${props.orderDetails.skuQuantity}` : ''}`
                    }</Text>
                </StyledTextContent>

            </StyledHistoryOrderLine>
        </StyledHistoryOrderLineWrapper>
    );
};

export default OrderHistoryOrderline;
